export default (state, data) => {
	console.info('🦑 SET_USER_DATA', data);
	data.communication_opt_in = data.communication_opt_in || false; // eslint-disable-line camelcase
	state.user.data = data;
};
